import { EventEmitter } from '@angular/core';
import { BookWidgetFieldUpdateTypes } from '../../../../constants/book-widget.constants';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';

export class MultiCityMobileAdvanceExtended {
  bookWidgetFieldChange!: EventEmitter<BookWidgetFieldUpdateEvent>;

  onToggleChange(
    event: boolean,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onInputFieldChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  clearConnectionAirport(flightIndex: number) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        airportCode: '',
        airportCity: '',
        flightIndex
      },
      type: BookWidgetFieldUpdateTypes.connectionAirport
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }
}
